module.exports = __webpack_public_path__ + "static/media/old-mahogany-brown.bc8a2929.jpg";